import { Component, OnInit } from '@angular/core';
import { filter } from 'lodash';
import { Feature } from 'ol';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { ArincFOMEnum } from 'src/app/models/ArincFOMEnum';
import { FilterModel } from 'src/app/models/filter';
import { FreqConversionUtil } from 'src/app/models/FreqConversionUtil';
import { icaoccModel } from 'src/app/models/icaoccModel';
import { ProceduresFilterService } from 'src/app/services/procedures-filter.service';
import { PointsService } from 'src/app/services/points.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { ProceduresService } from 'src/app/services/procedures.service';
import { SelectCoordinatePointsControlService } from 'src/app/popup/services/select-coordinate-points-control.service';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { ProcedureModel } from 'src/app/models/procedure';
import { FeatureType } from 'src/app/models/EnumTypes';
import { Style } from 'ol/style';
import { TabsService } from 'src/app/services/tabsService';
import { SaamTrafficService } from 'src/app/services/saamtrafficservice';

@Component({
  selector: 'app-procedures-filter',
  templateUrl: './procedures-filter.component.html',
  styleUrls: ['./procedures-filter.component.scss'],
  standalone: false
})
export class ProceduresFilterComponent implements OnInit {

  selectedField : string;
  selectedValue : string;
  values : string[] = [];
  filters : FilterModel[] = [];
  filterBy: string;
  selectedProcedure : ProcedureModel;


  dropdown_values_enabled: boolean = false;
  isReferenceAirportFilter: boolean = false;
  keyword = 'composedName';
  airportSelectOnMapActive : boolean = false;

  constructor(
    public saamService : SaamTrafficService,
    public proceduresFilterController : ProceduresFilterService,
    public procedureController : ProcedureControlService,
    public proceduresService : ProceduresService,
    public menuController : MenuManagementService,
    private toolsService : ToolsControlService,
    private pointsService : PointsService,
    public tabsService : TabsService,
    public  selectCoordinatePointService : SelectCoordinatePointsControlService,) {
      this.selectCoordinatePointService.tempProcedureLeg = [];
     }

  ngOnInit(): void {
    //this.typeChanged('type');
  }

  public typeChanged( $event ) {
    this.values = [];
    this.filterBy = $event;
    switch($event){
      case 'type':
        this.values.push("SID");
        this.values.push("STAR");
        this.values.push("EN-ROUTE");
        this.dropdown_values_enabled = true;
        this.isReferenceAirportFilter = false;
        break;
      case 'RNAV_Type':
          this.values.push("RNAV-5 (B-RNAV)");
          this.values.push("RNAV-1 (P-RNAV)");
          this.values.push("A-RNP");
          this.dropdown_values_enabled = true;
          this.isReferenceAirportFilter = false;
          break;
      case 'referenceAirport':
        this.dropdown_values_enabled = false;
        this.isReferenceAirportFilter = true;
        break;
      default:
        console.log($event);
    }
  }

  applyFilter() : void {
    this.proceduresService.filterProcedures(this.filters, true);
  }

  resetFilters() : void {
    let features : Feature[] = this.pointsService.getAllProceduresFeaturesFromLayers();
    this.proceduresService.informationMessage = "Displaying " + (features.length) + " of " + features.length + ".";

    this.pointsService.deleteProceduresFromMap();
    this.pointsService.fetchAndAddProcedures();
  }

  addFilter():void{
    let filter_item : FilterModel = new FilterModel();
    let selected = document.getElementById("filter_typeProcedures") as HTMLSelectElement;
    if (selected != null){
      filter_item.field = selected.options[selected.selectedIndex].text;
    }

    if (this.filterBy === "referenceAirport"){
      let selectedProcedure : ProcedureModel = this.selectCoordinatePointService.selectedProcedure;
      filter_item.value = selectedProcedure.airport;
      filter_item.airportPk = selectedProcedure.referenceAirportPk;
    }
    else {
      filter_item.value = (<HTMLInputElement>document.getElementById("valuesProcedures")).value;
    }


    this.filters.push(filter_item);
  }


  deleteSelectedFilterFromList(){
    this.filters.forEach(function(item, index, object) {
      if (item.isSelected) {
        object.splice(index, 1);
      }
    });
  }

  cancelWindow():void{
    this.proceduresFilterController.active = !this.proceduresFilterController.active;
    this.toolsService.navigationOnTop = false;
  }

  selectAirport(event : CoordinatePointModel) : void {
    this.selectCoordinatePointService.selectedProcedure.airport = event.composedName;
    this.selectCoordinatePointService.selectedProcedure.referenceAirportPk = event.id;
  }

  addToMap() : void {
    let selectedProcedures : ProcedureModel[] = [];
    this.procedureController.procedures.forEach( proc => {
      if(proc.isselected) {
        proc.mapstatus = true;
        selectedProcedures.push(proc);
        //this.procedureController.saveProcedure(this.selectedProcedure);
        //this.pointsService.addProcedureToMap(this.selectedProcedure);
      }
    });
    this.procedureController.bulkStatusUpdateProcedure(selectedProcedures);
  }

  removeFromMap() : void {
    let selectedProcedures : ProcedureModel[] = [];
    this.procedureController.procedures.forEach( proc => {
      if(proc.isselected) {
        proc.mapstatus = false;
        selectedProcedures.push(proc);
        //this.procedureController.saveProcedure(proc);
        //this.pointsService.deleteProcedureModelFromMap(proc);
      }
    });

    this.procedureController.bulkStatusUpdateProcedure(selectedProcedures);

  }

  deselectAll() {
    this.procedureController.procedures.forEach( proc => {
      proc.isselected = false;
    });
  }
  selectAll() {
    this.procedureController.procedures.forEach( proc => {
      proc.isselected = true;
    });
  }

}
